<template>
  <b-modal size="lg" :id="id" title="Listado de pallets" @show="onShow" @ok="onOk">
    <b-spinner v-if="loading"></b-spinner>
    <p v-if="!loading && items.length === 0">Nada que mostrar</p>
    <div v-if="!loading && items.length > 0">
      <b-table :items="items" :fields="fields" responsive foot-clone>
        <template #foot()="data">
          <span v-if="data.field.class === 'text-right'" class="text-right">{{ sumColumn(data.column) }}</span>
          <span v-else></span>
        </template>
        <template #cell(is_complete)="row">
          <i class="fa fa-lg fa-check text-success" v-if="row.item.is_complete"></i>
          <i class="fa fa-lg fa-close text-danger" v-else></i>
        </template>
      </b-table>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "PalletList",
  props: {
    id: {
      type: String
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      fields: [
        { key: "number", label: "Número" },
        { key: "_varieties", label: "Variedades" },
        { key: "_origins", label: "Huertos" },
        { key: "is_complete", label: "Completado", class: "text-center" },
        { key: "_total_quantity", label: "Q", class: "text-right" },
        { key: "_total_exportable_kilograms", label: "KExp", class: "text-right" }
      ]
    };
  },
  methods: {
    sumColumn(column) {
      const items = this.items;
      return items.reduce((acc, item) => acc + parseFloat(item[column]), 0);
    },
    async onShow() {
      this.loading = true;

      try {
        const response = await this.$axios.get(`/storage/pallet/?purchase_order=${this.data.id}&no_page`);
        this.items = response.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    },
    onOk() {
      this.items = [];
    }
  }
};
</script>

<style></style>
